import axios from 'axios';
import { Component } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import CommonToast from '../Toaster/CommonToast';
import CommonLoader from '../loaderComponent/CommonLoader';

export default class AddAttendance extends Component {
  constructor(props) {
    super(props);
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();

    // Get first and last day of current month
    const firstDay = new Date(currentYear, currentMonth, 1);
    const lastDay = new Date(currentYear, currentMonth + 1, 0);

    this.state = {
      customers: [],
      projects: [],
      loading: false,
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      color: "",
      attendanceDate: today.toISOString().split('T')[0], // Set default to today
      startTime: '',
      endTime: '',
      location: '',
      completed: false,
      minDate: firstDay.toISOString().split('T')[0],
      maxDate: lastDay.toISOString().split('T')[0]
    }
  }

  // ... (keep all other existing methods the same)

  handleAttendanceDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const today = new Date();
    const errors = { ...this.state.errors };

    if (selectedDate.getMonth() === today.getMonth() &&
      selectedDate.getFullYear() === today.getFullYear()) {
      delete errors.attendanceDate;
      this.setState({ attendanceDate: e.target.value, errors });
    } else {
      this.setState({
        showToast: true,
        toastMessage: "Please select a date within the current month",
        toastVariant: "danger",
        color: 'red'
      });
    }
  };


  handleStartTimeChange = (e) => {
    const startTime = e.target.value;
    const errors = { ...this.state.errors };
    if (startTime) delete errors.startTime;

    this.setState({ startTime, errors });
  };


  handleEndTimeChange = (e) => {
    const endTime = e.target.value;
    const errors = { ...this.state.errors };
    if (endTime) delete errors.endTime;

    this.setState({ endTime, errors });
  };

  handleLocationChange = (e) => {
    const location = e.target.value;
    const errors = { ...this.state.errors };
    if (location) delete errors.location;

    this.setState({ location, errors });
  };


  async componentDidMount() {
    this.setState({ loading: true });
    await this.fetchCustomers();
  }

  handleCustomerChange = (e) => {
    const customerId = e.target.value;
    const errors = { ...this.state.errors };
    if (customerId) delete errors.customerId;

    this.setState({
      customerId,
      projectId: "",
      endTime: "",
      attendanceDate: "",
      projects: [],
      starTime: '',
      location: '',
      errors
    }, () => {
      if (customerId) this.fetchProjects(customerId);
    });
  };


  fetchCustomers = async () => {
    try {
      const res = await axios.get("/users");
      this.setState({ customers: res.data });
    } catch (error) {
      console.error("Failed to fetch customers:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  fetchProjects = async (customerId) => {
    // debugger
    try {
      const res = await axios.get(`/employeeProject/emp/${customerId}`);
      this.setState({ projects: res.data.projects });
      console.log("this is project api", res.data)
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      this.setState({ loading: false });
    }
  };


  handleProjectChange = (e) => {
    const projectId = e.target.value;
    const errors = { ...this.state.errors };
    if (projectId) delete errors.projectId;
    this.setState({ projectId, errors });
  };


  validateForm = () => {
    const errors = {};
    if (!this.state.customerId) errors.customerId = "Employee is required";
    if (!this.state.projectId) errors.projectId = "Project is required";
    if (!this.state.attendanceDate) errors.attendanceDate = "Attendance is required";
    if (!this.state.startTime) errors.startTime = "Start Time is required";
    if (!this.state.endTime) errors.endTime = "End Time is required";
    if (!this.state.location) errors.location = "Location is required";

    return errors;
  };

  onSubmit = async (e) => {
    // debugger;
    e.preventDefault();

    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };


    // Validate form
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({
        errors,
        showToast: true,
        toastMessage: "Please fix validation errors",
        toastVariant: "danger", color: 'red'
      });
      return;
    }

    this.setState({ loading: true });

    try {
      // Prepare the payload
      const payload = {
        empid: this.state.customerId,
        projectId: this.state.projectId,
        date: this.state.attendanceDate,
        startTime: this.state.startTime,
        endTime: this.state.endTime,
        location: this.state.location,
        // Add any additional fields you need here
      };

      // Make API call
      await axios.post('/attendance/full', payload, { headers });

      // Handle success
      this.setState({
        loading: false,
        showToast: true,
        toastMessage: "Attendance added successfully!",
        toastVariant: "success",
        color: 'green'
        //completed: true
      });
      setTimeout(() => {
        this.setState({ completed: true })
      }, 2000);
      // Optionally reset form
      // this.resetForm();

    } catch (error) {
      console.error("Error adding attendance:", error);
      this.setState({
        loading: false,
        showToast: true,
        toastMessage: error.response?.data?.message || "Failed to add attendance",
        toastVariant: "danger",
        color: 'red'
      });
    }
  };

  handleBack = () => {
    this.setState({ completed: true });
  }
  // Update the render method to use these handlers:
  render() {
    const {
      loading,
      errors,
      customerId,
      projectId,
      customers,
      projects,
      attendanceDate,
      startTime,
      endTime,
      location,
      completed,
      minDate,
      maxDate
    } = this.state
    return (
      <div>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={loading}>
          <div className="container-fluid pt-4">
            {completed ? (
              <>
                <Redirect to="/attendance-list" />
              </>) : null
            }
            <Card>
              <Card.Header>
                Add Attendance
              </Card.Header>
              <Card.Body>
                <Form onSubmit={this.onSubmit}>
                  <Row>
                    <Col md={4}>
                      <Form.Group controlId='formCustomer'>
                        <Form.Label className="required">Employee</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={customerId}
                          onChange={this.handleCustomerChange}
                          isInvalid={!!errors?.customerId}
                        >
                          <option value="">Select Employee</option>
                          {customers.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.fullName}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.customerId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group controlId="formProject">
                        <Form.Label className="required">Project</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={projectId}
                          onChange={this.handleProjectChange}
                          isInvalid={!!errors?.projectId}
                        >
                          <option value="">Select Project</option>
                          {projects.map((project) => (
                            <option key={project.id} value={project.id}>
                              {project.name}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.projectId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group controlId="formPoDate">
                        <Form.Label className="required">Attendance Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={attendanceDate}
                          min={minDate}
                          max={maxDate}
                          onChange={this.handleAttendanceDateChange}
                          isInvalid={!!errors?.attendanceDate}
                        />
                        <Form.Control.Feedback type="invalid">{errors?.attendanceDate}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label className='required'>Start Time</Form.Label>
                        <Form.Control
                          type="time"
                          name="startTime"
                          value={startTime}
                          placeholder='Enter start Time'
                          isInvalid={!!errors?.startTime}
                          onChange={this.handleStartTimeChange}
                        />
                        <Form.Control.Feedback type="invalid">{errors?.startTime}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label className='required'>End Time</Form.Label>
                        <Form.Control
                          type="time"
                          name="endTime"
                          value={endTime}
                          isInvalid={!!errors?.endTime}
                          onChange={this.handleEndTimeChange}
                          placeholder='Enter end Time'
                        />
                        <Form.Control.Feedback type="invalid">{errors?.endTime}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label className='required'>Location</Form.Label>
                        <Form.Control
                          type="text"
                          name="location"
                          value={location}
                          placeholder='Enter location'
                          isInvalid={!!errors?.location}
                          onChange={this.handleLocationChange}
                        />
                        <Form.Control.Feedback type="invalid">{errors?.location}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className='add-cancel-btn '>
                    <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary mt-2" type="submit" >
                      Add
                    </Button>
                    <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel mt-2" onClick={this.handleBack}>Cancel</Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </div>
        </CommonLoader >
      </div >
    )
  }
}